module.exports = __webpack_public_path__ + "static/media/metagraphOnlineDocument.da5d193a.PNG";